// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  wait = wait ? wait : 250;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// Listen to CSS transitions
function whichTransitionEvent() {
  var t;
  var el = document.createElement('fakeelement');
  var transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
  }

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

/* Listen for a transition! */
var transitionEvent = whichTransitionEvent();


//get index of element
function getNodeindex(elm) {
  var c = elm.parentNode.children,
    i = 0;
  for (; i < c.length; i++)
    if (c[i] == elm) return i;
}

function isString(el) {
  return typeof el === 'string';
}

/* 
Helper function that sets a "direction" property on any animation (tween or timeline) 
to -1 if the playhead is going backwards, or 1 if forward. It updates every time the playhead moves.
It must get applied to the onUpdate callback in one of the following ways: 

1) Directly as a callback (it returns a function):
gsap.to(... {onUpdate: trackDirection(), ...})

2) Assigned to the animation:
let tl = gsap.timeline();
trackDirection(tl);

You can add configuration options (onToggle and/or onUpdate):
gsap.to(... {
  x: 100, 
  onUpdate: trackDirection({
    onToggle: direction => console.log("toggled direction to", direction),
    onUpdate: direction => console.log("updated animation")
  })
});

Or when assigned to the animation:
trackDirection({
  animation: tl,
  onToggle: direction => console.log("toggled direction to", direction),
  onUpdate: direction => console.log("updated animation")
});

Caveat: since "direction" is set whenever the playhead changes position, it won't 
update immediately. For example, if you call tween.reverse() and then immediately check 
(before the next tick), tween.direction will still report as 1 because the playhead 
hasn't moved yet. 
*/
function trackDirection(value) {
  typeof(value) !== 'object' && (value = { onUpdate: value });
  let prevTime = 0,
    prevReversed = false,
    anim = value.eventCallback ? value : value.animation,
    onUpdate = value.onUpdate,
    onToggle = value.onToggle;
  return anim ? anim.eventCallback('onUpdate', trackDirection({ onUpdate: onUpdate, onToggle: onToggle })) : function() {
    let time = this.totalTime(),
      reversed = time < prevTime;
    this.direction = reversed ? -1 : 1;
    if (reversed !== prevReversed) {
      onToggle && onToggle.call(this, this.direction);
      prevReversed = reversed;
    }
    prevTime = time;
    onUpdate && onUpdate.call(this, this.direction);
  };
}

function addEventListenerOnce(target, type, listener, addOptions, removeOptions) {
    target.addEventListener(type, function fn(event) {
        target.removeEventListener(type, fn, removeOptions);
        listener.apply(this, arguments);
    }, addOptions);
}


export { debounce, transitionEvent, getNodeindex, isString, trackDirection, addEventListenerOnce };
